import {
  PermissionAction,
  PermissionResource,
} from '../../../../../../api/types/settings/permissions/permission-group-details.type';

export const permissionResourceLabel = (
  resource: PermissionResource,
): string => {
  switch (resource) {
    case PermissionResource.PROGRAMS:
      return 'תכניות';
    case PermissionResource.STUDENTS:
      return 'סטודנטים';
    case PermissionResource.LECTURES:
      return 'מפגשים';
    case PermissionResource.PAYMENTS:
      return 'תשלומים';
    case PermissionResource.JOURNAL_ENTRIES:
      return 'פקודות יומן';
    case PermissionResource.PAYROLL:
      return 'שכר';
    case PermissionResource.MASAV_FILES:
      return 'קבצי מס״ב';
    case PermissionResource.DEPOSITS:
      return 'הפקדות';
    case PermissionResource.SCHOLARSHIPS:
      return 'מלגות';
    case PermissionResource.ACCOUNTS:
      return 'חשבונות';
    case PermissionResource.CONTACTS:
      return 'אנשי קשר';
    default:
      return resource;
  }
};

export const permissionActionLabel = (action: PermissionAction): string => {
  switch (action) {
    case PermissionAction.READ:
      return 'קריאה';
    case PermissionAction.CREATE:
      return 'יצירה';
    case PermissionAction.UPDATE:
      return 'עדכון';
    case PermissionAction.DELETE:
      return 'מחיקה';
    case PermissionAction.APPROVE:
      return 'אישור';
    case PermissionAction.EXPORT:
      return 'ייצוא';
    default:
      return action;
  }
};
